
import respUtility from '~/mixins/respUtility';
import { TOGGLE_WISH_LIST } from '@/api/apolloCustomerMutations';

export default {
  name: 'ListingProductsListItemImage',
  mixins: [respUtility],
  props: {
    product: {
      type: Object,
      required: true,
    },
    initialLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isPopup: false,
      imageLabelsVariants: ['daily_deals', 'sale', 'out_of_stock'],
      labels: {
        daily_deals: {
          value: 'daily_deals',
          component: 'ListingProductsListItemLabelDailyDeals',
        },
        sale: {
          value: 'sale',
          component: 'ListingProductsListItemLabelSale',
        },
        out_of_stock: {
          value: 'out_of_stock',
          component: 'ListingProductsListItemLabelOutOfStock',
        },
        clearance: {
          value: 'clearance',
          component: 'ListingProductsListItemLabelClearance',
        },
      },
    };
  },
  computed: {
    mainImage() {
      return this.product.images?.mainImage || {};
    },
    imgClasses() {
      const result = {};
      Object.keys(this.product.images).forEach((key) => {
        result[key] = this.getClasses(key);
      });
      return result;
    },
    productLabels() {
      return (this.product?.labels || []).filter((l) => this.imageLabelsVariants.includes(l));
    },
    productTag() {
      const routeName = this.$route.name;
      const allTags = this.product.tags?.allTags;
      if (routeName === 'clearance-deals') return 'clearance';
      if (routeName === 'daily-deals') return 'daily_deal';
      if (!allTags) return null;
      return allTags[0] || null;
    },
    hoverGallery() {
      return this.$store.state.listing.hoverGallery || [];
    },
    isMobile() {
      return this.$device.isMobileOrTablet || this.isTouchDevice;
    },
  },
  inject: ['fetchWishListIds'],
  methods: {
    getClasses(key) {
      return (this.product.images[key]?.classes && this.product.images[key].classes.length)
        ? this.product.images[key].classes.join(' ') : '';
    },
    clickOnHeart() {
      if (this.$auth.loggedIn) {
        this.toggleWishList();
        return;
      }
      this.popupContent = 'AccountLogin';
      this.isPopup = true;
    },
    async onLogin() {
      this.isPopup = false;
      await this.toggleWishList();
      await this.fetchWishListIds();
    },
    async toggleWishList() {
      this.isEmulatedHover = true;

      this.$nuxt.$emit('change-global-loading', true);
      try {
        const { wishlist: { toggleWishlistProduct } } = await this.$graphql.default
          .request(TOGGLE_WISH_LIST, { productId: Number(this.product.id), wishlistId: null }) || {};
        if (toggleWishlistProduct?.success) {
          this.$store.commit('listing/setWishList', Number(this.product.id));
        }
        this.$nuxt.$emit('change-global-loading', false);
        this.$store.commit('addMessage', {
          type: toggleWishlistProduct?.success ? 'wishlist' : 'error',
          content: `${toggleWishlistProduct?.message}`,
          additionalClass: 'notification-wish-list',
        });
      } catch (e) {
        this.$nuxt.$emit('change-global-loading', false);
        console.error(e);
      }
      this.isEmulatedHover = false;
    },
  },
};
